export const DripIcon = () => {
  return (
    <img
      width="32"
      height="32"
      src="/assets/logo-drip.png"
      alt="Drip email marketing"
    />
  );
};
